export default __webpack_public_path__ + "static/media/man.f4eb7830.svg";